(function () {
  'use strict';

  angular.module('wsLrs.services').factory('Dimensions', ['Utils', function DimensionsFactory(Utils) {
    return {
      isCompoundDimension: function isCompoundDimension(reportConfiguration) {
        var validStatementProperties = ["actors.person.id", "object.id"];
        return Utils._try(function () {
          return reportConfiguration.dimensions[0].statementProperty.includes('+') || reportConfiguration.dimensions.length === 2 && validStatementProperties.includes(reportConfiguration.dimensions[0].statementProperty) && validStatementProperties.includes(reportConfiguration.dimensions[1].statementProperty);
        }, false);
      },
      getValidOptionalDimensions: function getValidOptionalDimensions(primaryDimension) {
        var key = primaryDimension.val && primaryDimension.val.statementProperty ? primaryDimension.val.statementProperty : typeof primaryDimension === 'string' ? primaryDimension : primaryDimension.statementProperty;
        var byActivity = [{
          name: 'By activity',
          val: {
            type: 'STATEMENT_PROPERTY',
            statementProperty: 'object.id'
          }
        }];
        var byPerson = [{
          name: 'By person',
          val: {
            type: 'STATEMENT_PROPERTY',
            statementProperty: 'actors.person.id'
          }
        }];
        var optionalDimensions = {
          'actors.person.id': byActivity,
          'actors.person.id+object.id': byActivity,
          'object.id': byPerson,
          'object.id+actors.person.id': byPerson
        };
        return optionalDimensions[key];
      },
      separateCompoundDimension: function getName(comboDim) {
        var personDimension = {
          name: 'By person',
          val: {
            type: 'STATEMENT_PROPERTY',
            statementProperty: 'actors.person.id'
          }
        };
        var activityDimension = {
          name: 'By activity',
          val: {
            type: 'STATEMENT_PROPERTY',
            statementProperty: 'object.id'
          }
        };
        var dimensions = {
          'actors.person.id+object.id': [personDimension, activityDimension],
          'object.id+actors.person.id': [activityDimension, personDimension]
        };
        return dimensions[comboDim.statementProperty];
      },
      getCommonDimensions: function getCommonDimensions() {
        var dimensions = [];
        dimensions.push({
          name: 'By person',
          val: {
            type: 'STATEMENT_PROPERTY',
            statementProperty: 'actors.person.id'
          }
        });
        dimensions.push({
          name: 'By group',
          val: {
            type: 'STATEMENT_PROPERTY',
            statementProperty: 'actors.groups.id'
          }
        });
        dimensions.push({
          name: 'By activity',
          val: {
            type: 'STATEMENT_PROPERTY',
            statementProperty: 'object.id'
          }
        });
        dimensions.push({
          name: 'By activity type',
          val: {
            type: 'STATEMENT_PROPERTY',
            statementProperty: 'object.definition.type'
          }
        });
        dimensions.push({
          name: 'By day',
          val: {
            type: 'TIME',
            timePeriod: 'DAY'
          }
        });
        dimensions.push({
          name: 'By week',
          val: {
            type: 'TIME',
            timePeriod: 'WEEK'
          }
        });
        dimensions.push({
          name: 'By month',
          val: {
            type: 'TIME',
            timePeriod: 'MONTH'
          }
        });
        dimensions.push({
          name: 'By year',
          val: {
            type: 'TIME',
            timePeriod: 'YEAR'
          }
        });
        dimensions.push({
          name: 'By verb',
          val: {
            type: 'STATEMENT_PROPERTY',
            statementProperty: 'verb.id'
          }
        });
        dimensions.push({
          name: 'By id',
          val: {
            type: 'STATEMENT_PROPERTY',
            statementProperty: 'id'
          }
        });
        dimensions.push({
          name: 'By a statement property',
          val: {
            type: 'STATEMENT_PROPERTY'
          },
          other: true
        });
        dimensions.push({
          name: 'By all',
          val: {
            type: 'CONSTANT'
          }
        });
        return dimensions;
      },
      getCommonDimensionFromKey: function getCommonDimensionFromKey(keyOrDimension) {
        if (!keyOrDimension) {
          return null;
        }
        var key;
        var isStringKey = typeof keyOrDimension === 'string';
        var isDimension = keyOrDimension.statementProperty || keyOrDimension.timePeriod;
        var isDimensionWithName = keyOrDimension.val;
        if (isStringKey) {
          key = keyOrDimension;
        } else if (isDimension) {
          key = isDimension;
        } else if (isDimensionWithName) {
          key = keyOrDimension.val.statementProperty ? keyOrDimension.val.statementProperty : keyOrDimension.val.timePeriod ? keyOrDimension.val.timePeriod : null;
          if (!key) {
            return null;
          }
        }
        var properties = {
          'actors.person.id': {
            name: 'By person',
            val: {
              type: 'STATEMENT_PROPERTY',
              statementProperty: 'actors.person.id'
            }
          },
          'actors.person.id+object.id': {
            name: 'By person',
            val: {
              type: 'STATEMENT_PROPERTY',
              statementProperty: 'actors.person.id+object.id'
            }
          },
          'actors.groups.id': {
            name: 'By group',
            val: {
              type: 'STATEMENT_PROPERTY',
              statementProperty: 'actors.groups.id'
            }
          },
          'day': {
            name: 'By day',
            val: {
              type: 'TIME',
              timePeriod: 'DAY'
            }
          },
          'week': {
            name: 'By week',
            val: {
              type: 'TIME',
              timePeriod: 'WEEK'
            }
          },
          'month': {
            name: 'By month',
            val: {
              type: 'TIME',
              timePeriod: 'MONTH'
            }
          },
          'year': {
            name: 'By year',
            val: {
              type: 'TIME',
              timePeriod: 'YEAR'
            }
          },
          'object.id': {
            name: 'By activity',
            val: {
              type: 'STATEMENT_PROPERTY',
              statementProperty: 'object.id'
            }
          },
          'object.id+actors.person.id': {
            name: 'By activity',
            val: {
              type: 'STATEMENT_PROPERTY',
              statementProperty: 'object.id+actors.person.id'
            }
          },
          'object.definition.type': {
            name: 'By activity type',
            val: {
              type: 'STATEMENT_PROPERTY',
              statementProperty: 'object.definition.type'
            }
          },
          'context.platform': {
            name: 'By context platform',
            val: {
              type: 'STATEMENT_PROPERTY',
              statementProperty: 'context.platform'
            }
          }
        };
        var dimension = properties[key.toLowerCase()];
        if (dimension) {
          return dimension;
        } else {
          return {
            name: 'By statement property',
            val: {
              type: 'STATEMENT_PROPERTY',
              statementProperty: key
            }
          };
        }
      },
      getTimeDimensions: function getTimeDimensions(customValue) {
        var dimensions = [];
        dimensions.push({
          name: 'By day',
          val: {
            type: 'TIME',
            timePeriod: 'DAY'
          }
        });
        dimensions.push({
          name: 'By week',
          val: {
            type: 'TIME',
            timePeriod: 'WEEK'
          }
        });
        dimensions.push({
          name: 'By month',
          val: {
            type: 'TIME',
            timePeriod: 'MONTH'
          }
        });
        dimensions.push({
          name: 'By year',
          val: {
            type: 'TIME',
            timePeriod: 'YEAR'
          }
        });
        if (customValue) {
          dimensions.push({
            name: 'Custom',
            val: customValue
          });
        }
        return dimensions;
      },
      getNonTimeDimensions: function getNonTimeDimensions(hasGroups) {
        var dimensions = [];
        dimensions.push({
          name: 'By person',
          val: {
            type: 'STATEMENT_PROPERTY',
            statementProperty: 'actors.person.id'
          }
        });
        dimensions.push({
          name: 'By group',
          val: {
            type: 'STATEMENT_PROPERTY',
            statementProperty: 'actors.groups.id'
          },
          disabled: !hasGroups
        });
        dimensions.push({
          name: 'By activity',
          val: {
            type: 'STATEMENT_PROPERTY',
            statementProperty: 'object.id'
          }
        });
        dimensions.push({
          name: 'By activity type',
          val: {
            type: 'STATEMENT_PROPERTY',
            statementProperty: 'object.definition.type'
          }
        });
        dimensions.push({
          name: 'By context platform',
          val: {
            type: 'STATEMENT_PROPERTY',
            statementProperty: 'context.platform'
          }
        });
        dimensions.push({
          name: 'By a statement property',
          val: {
            type: 'STATEMENT_PROPERTY'
          },
          other: true
        });
        return dimensions;
      }
    };
  }]);
})();
